// extracted by mini-css-extract-plugin
module.exports = {"accordionDeal":"e_4p","buttonHolder":"e_5p","button":"e_6p"};